import { IconLeftOutlined, IconRightOutlined } from "@suse-o11y/icons";
import React from "react";

import { useUnmuteDrawerContext } from "../context";

export function RuleSelector() {
	const { ruleIndex, ruleCount, onSelect } = useUnmuteDrawerContext();

	return (
		<div className="join">
			<button
				aria-label="Previous rule"
				className="button button-tertiary join-item button-square"
				disabled={ruleIndex === 0}
				onClick={() => {
					onSelect(ruleIndex - 1);
				}}
				type="button"
			>
				<IconLeftOutlined className="text-xs" />
			</button>

			<p className="join-item mb-0 border border-grey-400 bg-core-fill-neutral-primary px-3 leading-7.5">
				Silencing rule {ruleIndex + 1} / {ruleCount}
			</p>

			<button
				aria-label="Next rule"
				className="button button-tertiary join-item button-square"
				disabled={ruleIndex >= ruleCount - 1}
				onClick={() => {
					onSelect(ruleIndex + 1);
				}}
				type="button"
			>
				<IconRightOutlined className="text-xs" />
			</button>
		</div>
	);
}
